import gql from 'graphql-tag'

import { orderType } from './fragment'

export default gql`
query getOrderType($id: ID!) {
	cashAssist {
		getOrderType(id: $id) {
            ...orderType
	      }
	}
}
${orderType}
`
